<template>
        <div>
        <!-- SINGLE VENTS -->
        <svg v-if="type == 1 || type == 3 || type == 6 || type == 7 || type == 8 || type == 16 || type == 30 || type == 21 || type == 23 || type == 26 || type == 46 || type == 55 || type == 50" :width="SFb1+42" :height="SFh+66">
            <!-- Frame -->
            <rect x="23" y="23" :width="SFb1-4" :height="SFh" stroke="grey" fill="lightblue" stroke-width="4"/>
            
            <!-- DIMENSIONS -->
            <template v-if="dim == true">
                <!-- Fb Dimension -->
                <text style="text-anchor: middle" :x="(SFb1/2)+23" y="15" font-size="20">{{Fb1}}</text>
                <line x1="21" y1="17" :x2="SFb1+21" y2="17" stroke="black" stroke-width=".5" />
                <line x1="21.25" y1="13" x2="21.25" y2="21" stroke="black" stroke-width=".5" />
                <line :x1="SFb1+20.75" y1="13" :x2="SFb1+20.75" y2="21" stroke="black" stroke-width=".5" />
                <text fill="blue" style="text-anchor: middle" :x="(SFb1/2)+23" :y="SFh+37" font-size="14">{{W1}}kg</text>
                <text v-if="type == 30" style="text-anchor: middle" :x="(SFb1/2)+23" :y="SFh+53" font-size="13" font-weight="bold">{{profile}}</text>
                <text v-if="type == 21 || type == 23 || type == 26" style="text-anchor: middle" :x="(SFb1/2)+23" :y="SFh+53" font-size="13" font-weight="bold">{{caption("addwin_Balcony")}}</text>
                <!-- Fh Dimension -->
                <!-- Right -->
                <template v-if="dir == 1 && type != 8">
                    <text style="text-anchor: middle" :x="SFb1+27" :y="(SFh/2)+23" :transform="rotFh90" font-size="20">{{Fh}}</text>
                    <line :x1="SFb1+25" y1="21" :x2="SFb1+25" :y2="SFh+25" stroke="black" stroke-width=".5" />
                    <line :x1="SFb1+21" y1="21" :x2="SFb1+29" y2="21" stroke="black" stroke-width=".5" />
                    <line :x1="SFb1+21" :y1="SFh+24.75" :x2="SFb1+29" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
                </template>
                <!-- Left -->
                <template v-if="dir == 2 || type == 8">
                    <text style="text-anchor: middle" x="15" :y="(SFh/2)+23" :transform="rotFh270" font-size="20">{{Fh}}</text>
                    <line x1="17" y1="21" x2="17" :y2="SFh+25" stroke="black" stroke-width=".5" />
                    <line x1="13" y1="21.25" x2="21" y2="21.25" stroke="black" stroke-width=".5" />
                    <line x1="13" :y1="SFh+24.75" x2="21" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
                </template>

                <!-- A Dimension -->
                <!-- Right -->
                <template v-if="type != 8 && type != 50 && type != 55 && dir == 1">
                    <text style="text-anchor: middle" x="15" :y="(SFh-SA/2)+21" :transform="rotA270"  font-size="20">{{A}}</text>
                    <line x1="17" :y1="(SFh-SA)+21" x2="17" :y2="SFh+25" stroke="black" stroke-width=".5" />  
                    <line x1="13" :y1="(SFh-SA)+21.25" x2="21" :y2="(SFh-SA)+21.25" stroke="black" stroke-width=".5" />
                    <line x1="13" :y1="SFh+24.75" x2="21" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
                </template>
                <!-- Left -->
                <template v-if="type != 8 && type != 50 && type != 55 && dir == 2">
                    <text style="text-anchor: middle" :x="SFb1+27" :y="(SFh-SA/2)+25" :transform="rotA90" font-size="20">{{A}}</text>
                    <line :x1="SFb1+25" :y1="(SFh-SA)+21" :x2="SFb1+25" :y2="SFh+25" stroke="black" stroke-width=".5" />
                    <line :x1="SFb1+21" :y1="(SFh-SA)+21" :x2="SFb1+29" :y2="(SFh-SA)+21" stroke="black" stroke-width=".5" />
                    <line :x1="SFb1+21" :y1="SFh+24.75" :x2="SFb1+29" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
                </template>
            </template>

            <!-- TURN MOVEMENT -->
            <!-- Right -->
            <template v-if="dir == 1 && (type == 1 || type == 16 || type == 6 || type == 3 || type == 30 || type == 21 || type == 23 || type == 26 || type == 46)">
                <line :x1="SFb1+17" y1="25" x2="25" :y2="(SFh - SA)+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 3|| type == 30 || type == 23 ? '5,5' : ''" />
                <line x1="25" :y1="(SFh-SA)+21" :x2="SFb1+17" :y2="SFh+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 3|| type == 30 || type == 23 ? '5,5' : ''" />
            </template>

            <!-- Left -->
            <template v-if="dir == 2 && (type == 1 || type == 16 || type == 6 || type == 3 || type == 30 || type == 21 || type == 23 || type == 26 || type == 46)">
                <line x1="25" y1="25" :x2="SFb1+17" :y2="(SFh - SA)+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 3|| type == 30 || type == 23 ? '5,5' : ''" />
                <line :x1="SFb1+17" :y1="(SFh - SA) + 21" x2="25" :y2="SFh+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 3|| type == 30 || type == 23 ? '5,5' : ''" />
            </template>

            <!-- TILT MOVEMENT -->
            <template v-if="type == 1 || type == 3 || type == 7 || type == 8 || type == 21 || type == 23 || type == 50 || type == 55">                    
            <line x1="25" :y1="SFh+21" :x2="(SFb1/2)+21" y2="25" stroke="black" stroke-width=".5" />
            <line :x1="(SFb1/2)+21" y1="25" :x2="SFb1+17" :y2="SFh+21" stroke="black" stroke-width=".5" />
            </template>


            <!-- HANDLE -->
            <template v-if="config == 0">
                <template v-if="dir == 1 && type != 8 && type != 50 && type != 55 && handle != ''">
                    <image :xlink:href="'/src/assets/R_' + handle + '.png'" x="21" :y="(SFh-SA)+21-(picH/2)" :height="picH" :width="picW" preserveAspectRatio="xMinYMid" />
                </template>
                <template v-if="dir == 2 && type != 8 && type != 50 && type != 55 && handle != ''">
                    <image :xlink:href="'/src/assets/L_' + handle + '.png'" :x="SFb1+21-(picW)" :y="(SFh-SA)+21-(picH/2)" :height="picH" :width="picW" preserveAspectRatio="xMaxYMid"/>
                </template>
                <template v-if="type == 8 && type != 50 && type != 55 && handle != ''">
                    <image :xlink:href="'/src/assets/L_' + handle + '.png'" :x="(SFb1/2)+21-(picW/2)" :y="21" :height="picH" :width="picW" :transform="'rotate(270 ' + ((SFb1/2)+21) + ' ' + (21 + (picH/2)) + ')'" preserveAspectRatio="xMaxYMid"/>
                </template>
            </template>

            <!-- HINGES -->
             <template v-if="config == 0">
            <template v-if="dir == 1 && hinge == 1">
                <image :xlink:href="'/src/assets/R_VIS.png'" :x="SFb1+21-picW" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMaxYMid" />
            </template>
            <template v-if="dir == 2 && hinge == 1">
                <image :xlink:href="'/src/assets/L_VIS.png'" :x="21" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMinYMid"/>
            </template>

             <template v-if="dir == 1 && hinge == 2">
                <image :xlink:href="'/src/assets/R_PRO.png'" :x="SFb1+17-picW" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMaxYMax" />
            </template>
            <template v-if="dir == 2 && hinge == 2">
                <image :xlink:href="'/src/assets/L_PRO.png'" :x="25" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMinYMax"/>
            </template>

            <template v-if="dir == 1 && hinge == 5">
                <image :xlink:href="'/src/assets/R_GO.png'" :x="SFb1+20-picW" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMaxYMax" />
            </template>
            <template v-if="dir == 2 && hinge == 5">
                <image :xlink:href="'/src/assets/L_GO.png'" :x="22" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMinYMax"/>
            </template>
             </template>
        </svg>

        <!-- DOUBLE VENTS -->
        <svg v-if="type == 2 || type == 4 || type == 60 || type == 22 || type == 24 || type == 27 || type == 31" :width="SFb1+SFb2+42" :height="SFh+66">
          <!-- Frame -->
          <rect x="23" y="23" :width="SFb1-4" :height="SFh" stroke="grey" fill="lightblue" stroke-width="4" />
          <rect :x="23+SFb1" y="23" :width="SFb2-4" :height="SFh" stroke="grey" fill="lightblue" stroke-width="4" />

          <!-- DIMENSIONS -->
          <template v-if="dim == true">
            <!-- Fb1 Dimension -->
            <text style="text-anchor: middle" :x="(SFb1/2)+23" y="15" font-size="20">{{Fb1}}</text>
            <line x1="21" y1="17" :x2="SFb1+21" y2="17" stroke="black" stroke-width=".5" />
            <line x1="21.25" y1="13" x2="21.25" y2="21" stroke="black" stroke-width=".5" />
            <line :x1="SFb1+20.75" y1="13" :x2="SFb1+20.75" y2="21" stroke="black" stroke-width=".5" />
            <text fill="blue" style="text-anchor: middle" :x="(SFb1/2)+23" :y="SFh+37" font-size="14">{{W1}}kg</text>
            <text v-if="type == 22 || type == 24 || type == 27" style="text-anchor: middle" :x="((SFb1 + SFb2)/2)+23" :y="SFh+53" font-size="13" font-weight="bold">{{caption("addwin_Balcony")}}</text>
            <!-- Fb2 Dimension -->
            <text style="text-anchor: middle" :x="SFb1+(SFb2/2)+23" y="15" font-size="20">{{Fb2}}</text>
            <line :x1="SFb1+21" y1="17" :x2="SFb1+SFb2+21" y2="17" stroke="black" stroke-width=".5" />
            <line x1="21.25" y1="13" x2="21.25" y2="21" stroke="black" stroke-width=".5" />
            <line :x1="SFb1+SFb2+20.75" y1="13" :x2="SFb1+SFb2+20.75" y2="21" stroke="black" stroke-width=".5" />
            <text fill="blue" style="text-anchor: middle" :x="SFb1+(SFb2/2)+23" :y="SFh+37" font-size="14">{{W2}}kg</text>

            <!-- Fh Dimension -->
            <!-- Right -->
            <template v-if="dir == 1">
              <text style="text-anchor: middle" :x="SFb1+SFb2+27" :y="(SFh/2)+23" :transform="rotSFh90" font-size="20">{{Fh}}</text>
              <line :x1="SFb1+SFb2+25" y1="21" :x2="SFb1+SFb2+25" :y2="SFh+25" stroke="black" stroke-width=".5" />
              <line :x1="SFb1+SFb2+21" y1="21" :x2="SFb1+SFb2+29" y2="21" stroke="black" stroke-width=".5" />
              <line :x1="SFb1+SFb2+21" :y1="SFh+24.75" :x2="SFb1+SFb2+29" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
            </template>
            <!-- Left -->
            <template v-if="dir == 2">
              <text style="text-anchor: middle" x="15" :y="(SFh/2)+23" :transform="rotSFh270" font-size="20">{{Fh}}</text>
              <line x1="17" y1="21" x2="17" :y2="SFh+25" stroke="black" stroke-width=".5" />
              <line x1="13" y1="21.25" x2="21" y2="21.25" stroke="black" stroke-width=".5" />
              <line x1="13" :y1="SFh+24.75" x2="21" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
            </template>

            <!-- A Dimension -->
            <!-- Right -->
            <template v-if="dir == 1">
              <text style="text-anchor: middle" x="15" :y="(SFh-SA/2)+21" :transform="rotSA270" font-size="20">{{A}}</text>
              <line x1="17" :y1="(SFh-SA)+21" x2="17" :y2="SFh+25" stroke="black" stroke-width=".5" />
              <line x1="13" :y1="(SFh-SA)+21.25" x2="21" :y2="(SFh-SA)+21.25" stroke="black" stroke-width=".5" />
              <line x1="13" :y1="SFh+24.75" x2="21" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
            </template>
            <!-- Left -->
            <template v-if="dir == 2">
              <text style="text-anchor: middle" :x="SFb1+SFb2+27" :y="(SFh-SA/2)+25" :transform="rotSA90" font-size="20">{{A}}</text>
              <line :x1="SFb1+SFb2+25" :y1="(SFh-SA)+21" :x2="SFb1+SFb2+25" :y2="SFh+25" stroke="black" stroke-width=".5" />
              <line :x1="SFb1+SFb2+21" :y1="(SFh-SA)+21" :x2="SFb1+SFb2+29" :y2="(SFh-SA)+21" stroke="black" stroke-width=".5" />
              <line :x1="SFb1+SFb2+21" :y1="SFh+24.75" :x2="SFb1+SFb2+29" :y2="SFh+24.75" stroke="black" stroke-width=".5" />
            </template>
          </template>

          <!-- TURN MOVEMENT -->
          <!-- French Casement -->
          <template v-if="dir == 1 && (type == 2 || type == 4 || type == 60 || type == 22 || type == 24 || type == 27 || type == 31)">
            <line x1="25" y1="25" :x2="SFb1+17" :y2="(SFh - SA)+21" stroke="black" stroke-width=".5" :stroke-dasharray=" type == 31 ? '5,5' : ''" />
            <line :x1="SFb1+17" :y1="(SFh-SA)+21" x2="25" :y2="SFh+21" stroke="black" stroke-width=".5" :stroke-dasharray=" type == 31 ? '5,5' : ''" />
          </template>
          <template v-if="dir == 2 && (type == 2 || type == 4 || type == 60 || type == 22 || type == 24 || type == 27 || type == 31)">
            <line :x1="SFb1+SFb2+17" y1="25" :x2="SFb1+25" :y2="(SFh-SA)+21" stroke="black" stroke-width=".5" :stroke-dasharray=" type == 31 ? '5,5' : ''" />
            <line :x1="SFb1+25" :y1="(SFh-SA)+21" :x2="SFb1+SFb2+17" :y2="SFh+21" stroke="black" stroke-width=".5" :stroke-dasharray=" type == 31 ? '5,5' : ''" />
          </template>
          <!-- Main Vent -->
          <template v-if="dir == 1 && (type == 2 || type == 4 || type == 60 || type == 22 || type == 24 || type == 27 || type == 31)">
            <line :x1="SFb1+SFb2+17" y1="25" :x2="SFb1+25" :y2="(SFh-SA)+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 4 || type == 31 ? '5,5' : ''" />
            <line :x1="SFb1+25" :y1="(SFh-SA)+21" :x2="SFb1+SFb2+17" :y2="SFh+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 4 || type == 31 ? '5,5' : ''" />
          </template>
          <template v-if="dir == 2 && (type == 2 || type == 4 || type == 60 || type == 22 || type == 24 || type == 27 || type == 31)">
            <line x1="25" y1="25" :x2="SFb1+17" :y2="(SFh - SA)+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 4 || type == 31 ? '5,5' : ''" />
            <line :x1="SFb1+17" :y1="(SFh-SA)+21" x2="25" :y2="SFh+21" stroke="black" stroke-width=".5" :stroke-dasharray="type == 4 || type == 31 ? '5,5' : ''" />
          </template>


          <!-- TILT MOVEMENT -->
          <template v-if="dir == 1 && (type == 2 || type == 4 || type == 22 || type == 24)">
            <line :x1="SFb1+25" :y1="SFh+21" :x2="SFb1+(SFb2/2)+21" y2="25" stroke="black" stroke-width=".5" />
            <line :x1="SFb1+(SFb2/2)+21" y1="25" :x2="SFb1+SFb2+17" :y2="SFh+21" stroke="black" stroke-width=".5" />
          </template>
          <template v-if="dir == 2 && (type == 2 || type == 4 || type == 22 || type == 24)">
            <line x1="25" :y1="SFh+21" :x2="(SFb1/2)+21" y2="25" stroke="black" stroke-width=".5" />
            <line :x1="(SFb1/2)+21" y1="25" :x2="SFb1+17" :y2="SFh+21" stroke="black" stroke-width=".5" />
          </template>

          <!-- HANDLE -->
          <template v-if="config == 0">
            <template v-if="dir == 1 && handle != '' ">
              <image :xlink:href="'/src/assets/R_' + handle + '.png'" :x="SFb1+21" :y="(SFh-SA)+21-(picH/2)" :height="picH" :width="picW" preserveAspectRatio="xMinYMid" />
            </template>
            <template v-if="dir == 2 && handle != '' ">
              <image :xlink:href="'/src/assets/L_' + handle + '.png'" :x="SFb1+21-picW" :y="(SFh-SA)+21-(picH/2)" :height="picH" :width="picW" preserveAspectRatio="xMaxYMid" />
            </template>
          </template>

          <!--HINGES -->
          <template v-if="config == 0">
            <template v-if="hinge == 1">
              <image :xlink:href="'/src/assets/R_VIS.png'" :x="SFb1+SFb2+21-picW" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMaxYMid" />
              <image :xlink:href="'/src/assets/L_VIS.png'" :x="21" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMinYMid" />
            </template>
            <template v-if="hinge == 2">
              <image :xlink:href="'/src/assets/R_PRO.png'" :x="SFb1+SFb2+17-picW" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMaxYMax" />
              <image :xlink:href="'/src/assets/L_PRO.png'" :x="25" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMinYMax" />
            </template>
            <template v-if="hinge == 5">
              <image :xlink:href="'/src/assets/R_GO.png'" :x="SFb1+SFb2+20-picW" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMaxYMax" />
              <image :xlink:href="'/src/assets/L_GO.png'" :x="22" :y="SFh+21-picH" :height="picH" :width="picW" preserveAspectRatio="xMinYMax" />
            </template>
          </template>
        </svg>     
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            picH: 50,
            picW: 50
        }
    },
    props: ['type', 'dir', 'hinge', 'handle', 'Fb1', 'Fb2', 'Fh', 'A', 'W1', 'W2', 'dim', 'scale', 'profile', 'config'],
    methods: {
      caption(term){
       var cpt = this.$store.getters.getTranslationByTerm(term);
       return cpt.caption;
    }
    },
    computed: {
        rotFh90() {
            return `rotate(90 ${(this.SFb1)+27}, ${(this.SFh/2)+23})`;
        },
        rotFh270() {
            return `rotate(270 15, ${(this.SFh/2)+23})`;
        },
        rotSFh90() {
            return `rotate(90 ${(this.SFb1 + this.SFb2)+27}, ${(this.SFh/2)+23})`;
        },
        rotSFh270() {
            return `rotate(270 15, ${(this.SFh/2)+23})`;
        },
        rotA90() {
            return `rotate(90 ${this.SFb1+27}, ${(this.SFh-this.SA/2)+25})`;
        },
        rotA270() {
            return `rotate(270 15,${(this.SFh-this.SA/2)+21})`;
        },
        rotSA90() {
            return `rotate(90 ${this.SFb1 + this.SFb2 +27}, ${(this.SFh-this.SA/2)+25})`;
        },
        rotSA270() {
            return `rotate(270 15,${(this.SFh-this.SA/2)+21})`;
        },
        SFb1() {
            return this.Fb1/this.scale;
        },
        SFb2() {
            return this.Fb2/this.scale;
        },
        SFh() {
            return this.Fh/this.scale;
        },
        SA() {
            return this.A/this.scale;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/windows/WindowGraph.vue